import React from "react";

import { Button } from "theme-ui";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";

import withTheme from "../../../withTheme";

export type PropsT = {
  handleClick: () => void;
};

const CloseButton = (props: PropsT) => {
  return (
    <Button variant="icon" onClick={props.handleClick} aria-label="Close">
      <FontAwesomeIcon icon={faTimes} size="lg"></FontAwesomeIcon>
    </Button>
  );
};

export default withTheme(CloseButton);
